"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _propTypes = require("prop-types");

var _Drawer = _interopRequireDefault(require("@material-ui/core/Drawer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Drawer = function Drawer(_ref) {
  var componentTag = _ref.componentTag,
      rest = _objectWithoutProperties(_ref, ["componentTag"]);

  return (0, _jsxRuntime.jsx)(_Drawer["default"], _objectSpread({
    ModalProps: {
      BackdropProps: {
        invisible: true
      }
    },
    PaperProps: {
      component: componentTag
    }
  }, rest));
};

Drawer.propTypes = {
  /**
   * Side from which the drawer will appear.
   */
  anchor: (0, _propTypes.oneOf)(['left', 'top', 'right', 'bottom']).isRequired,

  /**
   * Callback fired when the component requests to be closed.
   */
  onClose: _propTypes.func,

  /**
   * If `true`, the drawer is open.
   */
  open: _propTypes.bool,

  /**
   * The variant to use.
   */
  variant: (0, _propTypes.oneOf)(['permanent', 'persistent', 'temporary']),

  /**
   * The component used for the root node. Either a string to use a HTML element or a component.
   */
  componentTag: _propTypes.elementType
};
Drawer.defaultProps = {
  onClose: undefined,
  open: false,
  variant: 'temporary',
  componentTag: 'div'
};
var _default = Drawer;
exports["default"] = _default;